module.exports = __webpack_public_path__ + "img/cabinet_205.5d81758a.jpg";